import { DateTime } from "luxon";

const DEFAULT_ZONE = 'America/Sao_Paulo';

export function iso2view(date?: string | null, fromUtc = true): string {
    return date ? DateTime.fromISO(date, { zone: fromUtc ? 'utc' : DEFAULT_ZONE })
        .toLocal()
        .toFormat("dd/MM/yyyy HH:mm") : '-';
}

export function iso2time(date?: string, fromUtc = true): string {
    return date
        ? DateTime.fromISO(date, { zone: fromUtc ? 'utc' : DEFAULT_ZONE })
            .toLocal()
            .toFormat("HH:mm")
        : '-';
}

export function iso2show(date?: string | null): string {
    return date ? DateTime.fromISO(date, { zone: "utc" }).toLocal().toFormat("dd/MM/yyyy HH:mm") : '-';
}

export function iso2viewDate(date?: string): string {
    return date ? DateTime.fromISO(date).toFormat("dd/MM/yyyy") : '-';
}

export function iso2jsDate(date?: string): Date | null {
    return date ? DateTime.fromISO(date, {zone: 'utc'}).toLocal().toJSDate() : null;
}

export function iso2date(date?: string, fromUtc = true): DateTime | null {
    return date
        ? DateTime.fromISO(date, { zone: fromUtc ? 'utc' : DEFAULT_ZONE })
            .toLocal()
        : null;
}

export function date2date(date: DateTime): Date {
    return date.toJSDate();
}

export function jsdate2date(date: Date, utc = false): DateTime {
    if (utc) {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const hour = date.getHours();
        const minute = date.getMinutes();
        const second = date.getMinutes();
        return DateTime.fromObject({ year, month, day, hour, minute, second }, { zone: 'utc' });
    }
    return DateTime.fromJSDate(date);
}

export function date2db(date: DateTime): string {
    return date.toFormat("yyyy-MM-dd HH:mm:ss");
}

export function date2view(date?: DateTime): string {
    return date ? date.toFormat("dd/MM/yyyy") : '-';
}

export function date2viewText(date?: DateTime): string {
    return date ? date.setLocale(`pt-br`).toFormat("dd 'de' MMMM 'de' yyyy") : '-';
}

export function jsdate2iso(date: Date): string {
    return DateTime.fromJSDate(date).toUTC().toISO()!;
}
